<template>
  <!-- role="alert" so a failure is announced to screen readers, not just
       drawn on screen. red-400 clears 4.5:1 on the dark surface; red-500
       does not. -->
  <div
    v-if="error"
    role="alert"
    class="flex items-start gap-2 text-red-400 text-sm px-2 mt-2"
  >
    <Font-awesome-icon
      :icon="['fas', 'circle-exclamation']"
      class="mt-0.5 flex-none"
      aria-hidden="true"
    />
    <span>{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: "ErrorLabel",
  props: {
    error: { type: String },
  },
};
</script>
